const domiRobotDogExamples = [{
    id: 'robot-dog-talent-show',
    projectPath: 'static/examples/domi-robot-dog/talent-show.sb3',
    assetVersion: 'talent-show-v3',
    extensionIds: ['domiRobotDog'],
    mode: 'online',
    preview: 'dogShow',
    title: {
        id: 'gui.domiExamples.robotDogShow.title',
        defaultMessage: 'Quadruped Robot Talent Show'
    },
    description: {
        id: 'gui.domiExamples.robotDogShow.description',
        defaultMessage: 'A narrated show: wave hello, do push-ups twice, then dance and return to standing. ' +
            'Learn conditions, loops and timing.'
    },
    actions: [{
        id: 'gui.domiExamples.robotDogShow.connect',
        defaultMessage: 'Connect in the Device pane'
    }, {
        id: 'gui.domiExamples.robotDogShow.repeat',
        defaultMessage: 'Repeat hello + push-ups twice'
    }, {
        id: 'gui.domiExamples.robotDogShow.dance',
        defaultMessage: 'Dance finale + standing pose'
    }, {
        id: 'gui.domiExamples.robotDogShow.edit',
        defaultMessage: 'Change the order, repeat count and pauses'
    }]
}, {
    id: 'robot-dog-keyboard-training',
    projectPath: 'static/examples/domi-robot-dog/keyboard-training.sb3',
    assetVersion: 'keyboard-training-v3',
    extensionIds: ['domiRobotDog'],
    mode: 'online',
    preview: 'dogShow',
    title: {
        id: 'gui.domiExamples.dogKeyboard.title',
        defaultMessage: 'Keyboard Training Ground'
    },
    description: {
        id: 'gui.domiExamples.dogKeyboard.description',
        defaultMessage: 'Use arrow keys for single movements, and number keys for tricks. Learn key events and ' +
            'prevent overlapping actions with a busy variable.'
    },
    actions: [{
        id: 'gui.domiExamples.dogKeyboard.start',
        defaultMessage: 'Connect the dog, then click the green flag'
    }, {
        id: 'gui.domiExamples.dogKeyboard.arrows',
        defaultMessage: 'Arrow keys: forward, backward, turn left and right'
    }, {
        id: 'gui.domiExamples.dogKeyboard.tricks',
        defaultMessage: '1: hello; 2: push-ups; 3: dance; Space: stand'
    }, {
        id: 'gui.domiExamples.dogKeyboard.pacing',
        defaultMessage: 'One action at a time; not continuous hold-to-move'
    }]
}, {
    id: 'robot-dog-talent-blind-box',
    projectPath: 'static/examples/domi-robot-dog/talent-blind-box.sb3',
    assetVersion: 'talent-blind-box-v3',
    extensionIds: ['domiRobotDog'],
    mode: 'online',
    preview: 'dogShow',
    title: {
        id: 'gui.domiExamples.dogBlindBox.title',
        defaultMessage: 'Surprise Talent Box'
    },
    description: {
        id: 'gui.domiExamples.dogBlindBox.description',
        defaultMessage: 'Press Space to draw a random trick: hello, push-ups or dance. Learn random numbers, ' +
            'variables and conditional branches.'
    },
    actions: [{
        id: 'gui.domiExamples.dogBlindBox.draw',
        defaultMessage: 'Click the green flag, then press Space to draw'
    }, {
        id: 'gui.domiExamples.dogBlindBox.result',
        defaultMessage: 'Show the selected trick number on stage'
    }, {
        id: 'gui.domiExamples.dogBlindBox.branch',
        defaultMessage: 'Three conditions choose three different performances'
    }, {
        id: 'gui.domiExamples.dogBlindBox.edit',
        defaultMessage: 'Change the tricks and add new outcomes'
    }]
}, {
    id: 'robot-dog-fitness-coach',
    projectPath: 'static/examples/domi-robot-dog/fitness-coach.sb3',
    assetVersion: 'fitness-coach-v3',
    extensionIds: ['domiRobotDog'],
    mode: 'online',
    preview: 'dogShow',
    title: {
        id: 'gui.domiExamples.dogFitness.title',
        defaultMessage: 'Quadruped Robot Fitness Coach'
    },
    description: {
        id: 'gui.domiExamples.dogFitness.description',
        defaultMessage: 'Choose one to three rounds of push-ups and rest, track progress and celebrate with a wave. ' +
            'Learn adjustable loops and counters.'
    },
    actions: [{
        id: 'gui.domiExamples.dogFitness.rounds',
        defaultMessage: 'After the green flag, use 1/2/3 to choose rounds'
    }, {
        id: 'gui.domiExamples.dogFitness.start',
        defaultMessage: 'Press Space to start; default is two rounds'
    }, {
        id: 'gui.domiExamples.dogFitness.rest',
        defaultMessage: 'Push-ups, standing rest, then count a completed round'
    }, {
        id: 'gui.domiExamples.dogFitness.counter',
        defaultMessage: 'Watch the completed rounds counter on stage'
    }]
}];

export default domiRobotDogExamples;
